/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InviteAdminUserRequestDto
 */
export interface InviteAdminUserRequestDto {
    /**
     * Admin account email
     * @type {string}
     * @memberof InviteAdminUserRequestDto
     */
    email: string;
    /**
     * Admin first name
     * @type {string}
     * @memberof InviteAdminUserRequestDto
     */
    firstName: string;
    /**
     * Admin middle name
     * @type {string}
     * @memberof InviteAdminUserRequestDto
     */
    middleName?: string;
    /**
     * Admin last name
     * @type {string}
     * @memberof InviteAdminUserRequestDto
     */
    lastName: string;
}

/**
 * Check if a given object implements the InviteAdminUserRequestDto interface.
 */
export function instanceOfInviteAdminUserRequestDto(value: object): value is InviteAdminUserRequestDto {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function InviteAdminUserRequestDtoFromJSON(json: any): InviteAdminUserRequestDto {
    return InviteAdminUserRequestDtoFromJSONTyped(json, false);
}

export function InviteAdminUserRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InviteAdminUserRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'firstName': json['firstName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'lastName': json['lastName'],
    };
}

export function InviteAdminUserRequestDtoToJSON(json: any): InviteAdminUserRequestDto {
    return InviteAdminUserRequestDtoToJSONTyped(json, false);
}

export function InviteAdminUserRequestDtoToJSONTyped(value?: InviteAdminUserRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'firstName': value['firstName'],
        'middleName': value['middleName'],
        'lastName': value['lastName'],
    };
}

